/// <amd-module name="VSSUI/Components/PeoplePicker/PeoplePicker" />
import * as React from "react";
import * as Resources from "VSSUI/VSS.Resources.VSSUI";
import { NormalPeoplePicker, IBasePickerSuggestionsProps, IInputProps } from "OfficeFabric/Pickers";
import { IPeoplePickerProps } from "./PeoplePicker.Props";
import { format } from "VSS/Core/Util/String";
import { convertIdentityListToPersonaList } from "./PeoplePickerUtils";

/** @deprecated Please use import { IdentityPicker } from "VSSUI/IdentityPicker" */
export class PeoplePicker extends React.Component<IPeoplePickerProps> {
    private _peoplePicker = React.createRef<NormalPeoplePicker>();

    public render(): JSX.Element {
        const suggestionsProps: IBasePickerSuggestionsProps = {
            onRenderNoResultFound: this._onRenderNoIdentitiesFound,
            resultsFooter: this._resultsFooter
        };

        const inputProps: IInputProps = {
            placeholder: this.props.placeholder || Resources.PeoplePickerPlaceholderText
        };

        return (
            <NormalPeoplePicker
                ref={this._peoplePicker}
                className={"vss-PeoplePicker"}
                pickerSuggestionsProps={suggestionsProps}
                inputProps={inputProps}
                resolveDelay={200}
                searchingText={Resources.PeoplePickerLoadingText}
                onResolveSuggestions={this._getfilteredPersonas}
            />
        );
    }

    private _getfilteredPersonas = (filter: string) => {
        return convertIdentityListToPersonaList(this.props.pickerProvider.onFilterIdentities(filter));
    };

    private _resultsFooter = (): JSX.Element => {
        return this._peoplePicker.current && this._peoplePicker.current.items.length > 0 ? (
            <div className="vss-NoIdentitiesFound">{format(Resources.PeoplePickerResultsFoundText, this._peoplePicker.current.items)}</div>
        ) : null;
    };

    private _onRenderNoIdentitiesFound = (): JSX.Element => {
        return <div className="vss-NoIdentitiesFound">{Resources.PeoplePickerNoResultsText}</div>;
    };
}
